import { apiClient } from "../../services/api";

const state = () => ({
  youtube_lives: null,
});

const getters = {
  getYoutubeLives: state => {
    return state.youtube_lives;
  },
};

const actions = {
  async getYoutubeLives({ commit }, payload) {
    const { cod_producao } = payload
    try {
      const response = await apiClient.get(
        `/youtube/active-lives-from-db/${cod_producao}`
      );
      
      if (response.status === 200) {
        commit("setYoutubeLives", response.data.lives);
      }
    } catch (error) {
      return error.response.data;
    }
  },
};

const mutations = {
  setYoutubeLives(state, payload) {
    state.youtube_lives = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
